import { createContext } from 'react';
import { NOTIFICATION_CONTEXT, Notification } from './notification_context.types';

export const NotificationContext = createContext<NOTIFICATION_CONTEXT>({
  addNotification: (notification: Notification) => '',
  deleteNotification: (id: string) => {},
});
